module.exports = __webpack_public_path__ + "img/login_banner_2.264c4b3c.png";